import React from 'react';
import numeral from 'numeral';
import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';

import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';

const styles = () => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  edit: {
    fontSize: 'medium',
  },
  expandedRow: {
    backgroundColor: '#f3f3f3',
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  buttonCell: {
    whiteSpace: 'nowrap',
  },
  totalsTable: {
    marginTop: '1rem',
  },
  fileCell: {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  totalsCell: {
    border: 0,
    fontWeight: 'bold',
  },
});

const Details = styled.div`
  font-size: 11px;
  color: #444;
`;

const Row = props => {
  const { classes, row } = props;

  return (
    <MuiTableRow className={classes.root}>
      <MuiTableCell>
        <div>{row.title !== ' - ' ? row.title : '<unknown>'}</div>
        <Details>{row.isrc ? `ISRC: ${row.isrc}` : ''}</Details>
        <Details>{row.upc ? `UPC(s): ${row.upc}` : ''}</Details>
      </MuiTableCell>
      <MuiTableCell align="right">${row.gross_revenue_usd}</MuiTableCell>
      <MuiTableCell align="right">{numeral(row.consumption_count).format('0,###,###')}</MuiTableCell>
      <MuiTableCell align="right">{row.royalties_created}</MuiTableCell>
      <MuiTableCell>{row.error}</MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(Row);
